export default __webpack_public_path__ + "static/step0303-41121a5b81c4e09c080a8c7f38bd4424.png";